import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const a=i("cx",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
        >
            <path
                d="M20 0L5 21.3671C3.84616 23.0886 1.92308 24 0 24L15 2.63291C16.1538 1.01266 17.9808 0 20 0Z"
                fill="url(#paint0_linear_9091_44811)"
            />
            <path
                d="M8.36956 7.28857L9.23494 8.50376L7.60032 10.8329L3.17725 4.45312C5.19648 4.55439 7.11956 5.56705 8.36956 7.28857Z"
                fill="url(#paint1_linear_9091_44811)"
            />
            <path
                d="M16.9243 19.5458C14.809 19.5458 12.8859 18.5331 11.6359 16.7103L10.7705 15.4951L12.4051 13.166L16.9243 19.5458Z"
                fill="url(#paint2_linear_9091_44811)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_9091_44811"
                    x1="0.472222"
                    y1="10.4151"
                    x2="20.4033"
                    y2="10.4492"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_9091_44811"
                    x1="3.32027"
                    y1="7.2217"
                    x2="9.3571"
                    y2="7.23346"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_9091_44811"
                    x1="10.9158"
                    y1="15.9346"
                    x2="17.0484"
                    y2="15.9467"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    `);export{a as ChicksX};
